import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";
import { debounce } from "lodash";
import { Trans, Translation } from 'react-i18next';

class FeedbackOverlay extends Component {
    constructor(props) {    
        super(props);

        this.submitFeedback = debounce(this.submitFeedback.bind(this), 500);
        this.updateForm = this.updateForm.bind(this);

        this.state = {
            feedback_form: {}
        };

        //
    }

    componentDidMount() {
    }

    submitFeedback() {
        var self = this; 

        axios.post('/ajax/feedback', this.state.feedback_form)
        .then(function(response) {
            showStatusMsg(response?.data.message, 'success');
            if (self.props.closeModal) self.props.closeModal();
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    updateForm(e) {
        var value = e.target.value
        var name = e.target.name 

        var feedback_form = this.state.feedback_form
        feedback_form[name] = value

        this.setState({
            feedback_form: feedback_form
        })
    }

    render(props) {
        return (
            <div className = "reveal" id = "feedback-overlay" style={{display: "block",top:"0"}}> 
                <div className = "card">
                    <div className = "card-divider">
                        <span className = "card-header-title"><Trans>Send Us Feedback</Trans></span>
                        <button className="close-button" data-close aria-label='Close modal' type='button' onClick={this.props.closeModal}>
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                    <div className = "card-section">
                        <Translation>
                            {
                                (t) => <textarea name = "feedback" placeholder = {t("Enter Feedback")} onChange={this.updateForm}/>
                            }
                        </Translation>
                        
                    </div>
                    <div className = "card-section">
                        <div className = "button-group float-right">
                            <a className = "button mr-8" onClick={this.props.closeModal}><Trans>Cancel</Trans></a>
                            <a className = "button primary" onClick={this.submitFeedback}><Trans>Submit</Trans></a>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(FeedbackOverlay)